import { stringify } from 'querystring'
import React, { useState, useEffect } from 'react'
import { OAuthApi } from '@backstage/core-plugin-api';

const auth = require('google-auth-library');

const { CloudBuildClient } = require('@google-cloud/cloudbuild')

// import { google } from "googleapis";
// const { GoogleAuth } = require('google-auth-library');
// const { google } = require('googleapis');

// const builds=google.cloudbuild('v1')
// const compute = google.compute('v1');

// google.cloudbuild()

const cred = {
  "client_id": "1002226406607-482qb20oft489pqu9tt6vr6m6a86ssq1.apps.googleusercontent.com",
  "project_id": "retbgbm",
  "client_secret": "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",
  "auth_uri": "https://accounts.google.com/o/oauth2/auth",
  "token_uri": "https://oauth2.googleapis.com/token",
}

const Builds = () => {


  async function quickstart(
    projectId = 'YOUR_PROJECT_ID', // Your Google Cloud Platform project ID
    triggerId = 'YOUR_TRIGGER_ID', // UUID for build trigger.
    branchName = 'BRANCH_TO_BUILD' // Branch to run build against.
  ) {
    // Imports the Google Cloud client library
    // const { CloudBuildClient } = require('@google-cloud/cloudbuild');


    const oauth2client = new auth.OAuth2Client(cred.client_id, cred.client_secret, "https://backstage.alpha-x-labs.com");
    const authUrl = oauth2client.generateAuthUrl({
      access_type: 'offline',
      scope: [    // scopes for Dialogflow
        'https://www.googleapis.com/auth/cloud-platform',
      ],
      redirect_uri:"https://backstage.alpha-x-labs.com",
      // include_granted_scopes
      
    });

    console.log("urlparam", authUrl)

    // Creates a client
    const cb = new CloudBuildClient();

    // Note: for Private Pools, you'll have to specify an API endpoint value
    // For example:
    // const cb = new CloudBuildClient({ apiEndpoint: '<YOUR_POOL_REGION>-cloudbuild.googleapis.com' });

    // Starts a build against the branch provided.
    const [resp] = await cb.runBuildTrigger({
      projectId:"retbgbm",
      triggerId:"btg-backstage",
      source: {
        projectId:"btg-lab-backstage",
        dir: './',
        branchName:"development",
      },
    });
    console.info(`triggered build for ${triggerId}`);
    const [build] = await resp.promise();

    const STATUS_LOOKUP = [
      'UNKNOWN',
      'Queued',
      'Working',
      'Success',
      'Failure',
      'Error',
      'Timeout',
      'Cancelled',
    ];
    for (const step of build.steps) {
      console.info(
        `step:\n\tname: ${step.name}\n\tstatus: ${STATUS_LOOKUP[build.status]}`
      );
    }
  }

  async function listBuildTriggers(
    projectId = 'retbgbm' // Your Google Cloud Platform project ID
  ) {
    // Imports the Google Cloud client library
    const { CloudBuildClient } = require('@google-cloud/cloudbuild');

    // Creates a client
    const cb = new CloudBuildClient();

    // What project should we list triggers for?
    const request = {
      projectId,
    };

    const [result] = await cb.listBuildTriggers(request);
    console.info(JSON.stringify(result, null, 2));
  }

  useEffect(() => {
    listBuildTriggers()
  }, [])
  return (
    <div>
      sadsfgchv
    </div>
  )
}

export default Builds
